import { useContext } from 'react';

import { PreviewStateContext } from '../_providers/PreviewStateProvider';

export const useCodePreviewState = () => useContext(PreviewStateContext);
